import { render } from "./StaffDatatableTDDoctorName.vue?vue&type=template&id=7794a95c&scoped=true"
import script from "./StaffDatatableTDDoctorName.vue?vue&type=script&lang=js"
export * from "./StaffDatatableTDDoctorName.vue?vue&type=script&lang=js"

import "./StaffDatatableTDDoctorName.vue?vue&type=style&index=0&id=7794a95c&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7794a95c"]])

export default __exports__